module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cw-3fc4503762b62953af04fb0bccc1436c.svg";